import { FileOperation } from './file-operation';
import { UserConnection } from '../../../shared/models/user';

export class FileDetails {
  public readonly id!: number;
  public readonly azure_reference!: string;
  public readonly blob_name!: string;
  public readonly file_name!: string;
  public readonly file_size?: number;
  public readonly upload_status!: FileUploadStatus;
  public readonly uploaded_datetime!: string;
  public readonly uploaded_user!: UserConnection;
  public readonly operations!: FileOperation[];
  public readonly sharing_status!: number;
}

export interface SharingInfo {
  users: { id: number; name: string }[];
  connections: { id: number; name: string }[];
}

export enum FileUploadStatus {
  Pending = 1,
  Success = 2,
  Failed = 3,
  Malicious = 4,
}

export const SharingStatus = {
  NOT_UPLOADED: 1,
  PENDING_APPROVAL: 2,
  APPROVED: 3,
  REJECTED: 4,
} as const;

export const PDMShareAction = {
  APPROVE: 1,
  REJECT: 2,
} as const;
